import { Pipe, PipeTransform } from '@angular/core';
import cronstrue from 'cronstrue';
import { isNil } from 'lodash-es';

@Pipe({
  name: 'cron',
  standalone: false
})
export class CronPipe implements PipeTransform {
  transform(value) {
    return !isNil(value)
      ? cronstrue.toString(value)
      : 'Invalid';
  }
}
